import React from 'react';
import InternalNavbar from '../components/Navbar/InternalNavbar';
import Hero from '../components/Hero/Hero';
import Skills from '../components/Skills/Skills';
import Education from '../components/Education/Education';
import Experience from '../components/Experience/Experience';
import Projects from '../components/Projects/Projects';
import Achievements from '../components/Achievements/Achievements';
import Certifications from '../components/Certifications/Certifications';
import Contact from '../components/Contact/Contact';

const Portfolio = () => {
  return (
    <div className="portfolio">
      <InternalNavbar />
      <Hero />
      <Skills />
      <Education />
      <Experience />
      <Projects />
      <Achievements />
      <Certifications />
      <Contact />
    </div>
  );
};

export default Portfolio;
